import axios from '@/lib/drupal/api/axiosInstance';
import { AxiosResponse } from 'axios';
import { logErrorEvent } from 'react-commons';

interface DrupalArticleData {
  nid: string
  created: string
  published_at: string
  title: string
  body: string
  view_node: string
}

export interface ArticleData {
  uid: string
  createdAt: string
  publishedAt: string
  title: string
  body: string
}

export default class ArticlesModel {
  static transform (rawData: DrupalArticleData): ArticleData {
    const body = rawData.body.replace(
      /\{\{copyright\}\}/g, 
      `Copyright © ${new Date().getFullYear()}`
    );

    return {
      uid: rawData.nid,
      createdAt: rawData.created,
      publishedAt: rawData.published_at,
      title: rawData.title,
      body,
    };
  }

  static async getArticleBySlug (slug: string): Promise<ArticleData> {
    let response: AxiosResponse;
    try {
      response = await axios.request({
        method: 'get',
        url: '/api/node/article/alias?route=' + slug.replace('faq/', 'faq_'),
      });
    } catch (error) {
      logErrorEvent('Get Article By Slug', false, error);
      // throw error;
    }

    if (!response.data || !response.data[ 0 ]) {
      const error = new Error('Article Not Found');
      logErrorEvent(error.name, false, error);
      // throw error;
    }

    return ArticlesModel.transform(response.data[ 0 ]);
  }
}
